import { Quote } from "lucide-react";

export default function Testimonials({ items = [] }) {
  const isEmpty = !items || items.length === 0;
  const hasPlaceholder = !isEmpty && items.some((t) => t && t.is_placeholder);

  return (
    <section className="py-24 md:py-32 bg-[#F7F5F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12 reveal">
          <div className="max-w-xl">
            <div className="text-[11px] uppercase tracking-[0.35em] text-[#985F47] mb-5">Guest words</div>
            <h2 className="serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tightest text-[#2C392F] font-light">
              In their <span className="italic text-[#985F47]">own words.</span>
            </h2>
          </div>
          {hasPlaceholder && (
            <span className="text-[11px] uppercase tracking-[0.3em] text-[#985F47] italic">
              Some entries are placeholders until verified guest reviews are added
            </span>
          )}
        </div>

        {isEmpty ? (
          <div
            data-testid="testimonials-empty"
            className="reveal bg-[#EFEAE4] border border-dashed border-[#2C392F]/20 rounded-2xl p-10 md:p-14 text-center"
          >
            <Quote className="mx-auto text-[#985F47]" strokeWidth={1.4} />
            <p className="serif text-2xl md:text-3xl text-[#2C392F] mt-5 italic leading-snug max-w-xl mx-auto">
              Guest words will appear here once added.
            </p>
            <p className="mt-4 text-sm text-[#4A4D4A] max-w-md mx-auto">
              You can add testimonials anytime from the admin panel: <span className="font-medium">Admin → Testimonials → Add new</span>.
            </p>
          </div>
        ) : (
          <div className="grid md:grid-cols-3 gap-5">
            {items.map((t, i) => (
              <figure
                key={t.id || i}
                data-testid={`testimonial-${i}`}
                className="reveal bg-[#EFEAE4] rounded-2xl p-8 md:p-10 border border-[#2C392F]/10 hover:border-[#985F47]/40 transition-all flex flex-col"
              >
                <Quote className="text-[#985F47]" strokeWidth={1.4} />
                <blockquote className="serif text-2xl md:text-[26px] text-[#2C392F] leading-[1.2] mt-6 italic">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-auto pt-8">
                  <div className="text-[15px] text-[#2C392F]">{t.guest_name}</div>
                  {t.city && (
                    <div className="text-[11px] uppercase tracking-[0.25em] text-[#985F47] mt-1">{t.city}</div>
                  )}
                </figcaption>
              </figure>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
